export const Dimensions = {
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  13: "52px",
  14: "56px",
  15: "60px",
  16: "64px",
  17: "68px",
  18: "72px",
  19: "76px",
  20: "80px",
  rem: {
    /* 4px */
    1: "0.25rem",
    /* 8px */
    2: "0.5rem",
    /* 12px */
    3: "0.75rem",
    /* 16px */
    4: "1rem",
    /* 20px */
    5: "1.25rem",
    /* 24px */
    6: "1.5rem",
    /* 28px */
    7: "1.75rem",
    /* 32px */
    8: "2rem",
    /* 36px */
    9: "2.25rem",
    /* 40px */
    10: "2.5rem",
    /* 44px */
    11: "2.75rem",
    /* 48px */
    12: "3rem",
    /* 52px */
    13: "3.25rem",
    /* 56px */
    14: "3.5rem",
    /* 60px */
    15: "3.75rem",
    /* 64px */
    16: "4rem",
    /* 68px */
    17: "4.25rem",
    /* 72px */
    18: "4.5rem",
    /* 76px */
    19: "4.75rem",
    /* 80px */
    20: "5rem",
  },
} as const;
